
import { Options, Vue } from "vue-class-component";
import { mapState, mapMutations } from "vuex";
import Common from '@/utils/common'
import Moment from "moment";
import Confirm from "@/components/Confirm.vue";
import ShareBtn from "@/components/ShareBtn.vue";
import HomeModal from "@/components/HomeModal.vue";
@Options({
  components: { Confirm, ShareBtn , HomeModal},
  data() {
    return {
      nowIndex: 0, //当前题目索引
      timeStr: "", //倒计时字符串
      hasChoose: false, //当前题目是否已选答案
      answer: {}, //选择的答案
      questions: [],
      session: "",
      optionLabel: ['A','B','C','D','E','F','G','H'],
      questionTypes: {
        'radio': '单选题',
        'check': '多选题',
        'judge': '判断题'
      },
      showConfirm: false,
      timeCount: 0,
      showModal: false,
      modalText: ''
    };
  },
  watch: {
    nowIndex(i) {
      const { id, type } = this.nowItem;
      if(!this.answer[id]) this.answer[id] = [];
      this.hasChoose = id && (this.answer[id].length > 0) ? true : false;
    },
  },
  computed: {
    ...mapState(["examAid", "userInfo",]),
    nowItem() {
      return this.questions[this.nowIndex]
    }
  },
  methods: {
    ...mapMutations(["SET_MYRESULT"]),
    timeOut() {
      this.time && clearInterval(this.time);
      this.$common.toast("倒计时结束，自动提交答案");
      this.sendAnswer(true);
    },
    //获取题目
    getQuestions(): void {
      this.$common.pageLoading(true)
      this.$request(
        "/answer/subject",
        {
          aid: this.examAid,
          userinfo: this.userInfo,
        },
        "post"
      )
        .then((data: any) => {
          this.$common.pageLoaded()
          this.questions = data.list;
          this.session = data.session;
          this.timeCount = data.times;
          this.setTimeCountDown();
        })
        .catch((err: any) => {
          this.$common.pageLoaded()
          this.$common.toast(err.errmsg || "获取失败");
        });
    },
    //选择答案
    chooseClick(index: number) {
      const { id, type } = this.nowItem;
      if(type === 'radio' || type === 'judge') {
        this.answer[id] = [index];
      }
      if(type === 'check') {
        if(!this.answer[id]) this.answer[id] = [];
        const i = this.answer[id].indexOf(index);
        if(i > -1) {
          this.answer[id].splice(i, 1)
        }
        else {
          this.answer[id].push(index)
        }
      }
      this.answer[id] = this.answer[id].sort();
      this.hasChoose = true;
    },
    prevClick() {
      if (this.nowIndex > 0) {
        this.nowIndex--;
      }
    },
    nextClick() {
      if (!this.hasChoose || this.nowItem.id && this.answer[this.nowItem.id] && this.answer[this.nowItem.id].length === 0) {
        this.$common.toast("请先选择答案");
        return;
      }
      if (this.nowIndex < this.questions.length - 1) {
        this.nowIndex++;
      }
    },
    confirmCancel() {
      this.$common.track("click", `点击答题取消按钮`);
      this.showConfirm = false;
    },
    confirmSubmit() {
      this.$common.track("click", `点击答题确认按钮`);
      this.showConfirm = false;
      this.sendAnswer();
    },
    modalCancel() {
      this.$common.track("click", `点击答题取消按钮`);
      this.showModal = false;
    },
    modalSubmit() {
      this.$common.track("click", `点击答题确认按钮`);
      this.showModal = false;
      this.sendAnswer();
    },

    //提交
    submitClick() {
      // if (!this.hasChoose) {
      //   this.$common.toast("请先选择答案");
      //   return;
      // }
      const notAnswerIndex = this.questions.reduce((t: string, v: any, i: number) => {
        return t += (!this.answer[v.id] || this.answer[v.id].length == 0) ? (i + 1 + (i < this.questions.length -1 ? '、' : '')): ''
      }, '')
      if(notAnswerIndex === '') {
        return this.showConfirm = true;
      }
      this.modalText = `<div style="color: #000"><b style="color: red">您有未完成的题目</b>，建议您完成后再提交试卷，提交试卷后不可更改。</div><div style="color: #999;margin-top: 1em; max-height: 3em; line-height: 1.5; overflow: auto">未完成的题目：${notAnswerIndex}题目</div>`
      this.showModal = true;
      window.scrollTo(0,0)
    },
    sendAnswer(isTimeout = false) {
      this.$common.pageLoading(true)
      this.questions.map((v:any, i:number) => {
        if(!this.answer[v.id]) {
          this.answer[v.id] = [];
        }
      })
      // for(let key in this.answer) {
      //   if(!this.answer[key] || this.answer[key].length == 0) {
      //     delete this.answer[key]
      //   }
      // }
      this.$request(
        "/answer/submit",
        {
          session: this.session,
          answer: this.answer,
          userinfo: this.userInfo,
          aid: this.examAid,
        },
        "post"
      )
        .then((data: any) => {
          this.SET_MYRESULT({
            ...data,
            dateTime: Moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            myAnswer: this.answer,
            questions: this.questions.map((v: any)=>v.id),
            isTimeout: isTimeout ? true : false,
            timesStr: Common.getDiffStr(data.times || 0)
          });
          this.$router.replace("/result");
        })
        .catch((err:any) => {
          // 答题次数已满
          if(err && err.errno === 2014) {
            this.$common.toast("今日答题次数已用完")
          }
          else if(err && err.errno === 1001) {
            this.$common.toast("答题超时，请重新答题")
          }
          else {
            this.$common.toast(err.errmsg || "成绩上传失败");
          }
          setTimeout(() => this.$router.replace("/examhome"), 1000)

        });
    },
    // 时间倒计时
    setTimeCountDown() {
      if(!this.timeCount) return;
      let end = Moment().add(this.timeCount + 1, "second"); //结束时间
      this.time = setInterval(() => {
        let start = Moment(new Date()); //获取开始时间
        let diff = end.diff(start); //时间差
        this.timeStr = `${(Moment.duration(diff).minutes() < 10 ? "0" : "") +
          Moment.duration(diff).minutes()}:${(Moment.duration(diff).seconds() <
        10
          ? "0"
          : "") + Moment.duration(diff).seconds()}`;
        //倒计时完毕
        if (diff < 1000) {
          this.timeOut();
        }
      }, 1000);
    }
  },
  mounted() {
    this.$common.pageLoaded();
    this.$common.track("load", "进入答题页");

    if(this.userInfo.token) this.getQuestions();
  },
  unmounted() {
    if (this.time) clearInterval(this.time);
  }
})
export default class Exam extends Vue {}
